export enum TREE_TYPES {
  EVENTS = 'events',
  INSIGHTS = 'insights',
}

export enum ICON_TYPES {
  DOT_BLUE = 'dotBlue',
  PURPLE_PENCIL = 'purplePencil',
  GREEN_Z = 'greenZ',
  ACTION = 'action',
  EYE = 'eye',
}

export const WELLBEING_ICONS = ['redArrowDown', 'notesCircle', 'greenArrowUp'];
